export default class ArrayUtils {
  /**
   * Split the provided array into an array of arrays whose length is equal to
   * the chunk size (or as many are left over in the last array);
   *
   * @param {Array<object>} array the original array
   * @param {number} chunkSize the number of items to include in the current
   * array before starting a new one
   * @throws {TypeError} if the provided array is not an instance of an Array
   * @return {Array<Array<object>>} the split array
   */
  static splitArrayIntoChunks(array, chunkSize) {
    const isArray = Array.isArray(array);
    if (!isArray) {
      throw new TypeError('Array must be an instance of an Array.');
    }

    if (chunkSize <= 0) {
      throw new Error('Chunk size must be greater than zero.');
    }

    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      const chunk = array.slice(i, i + chunkSize);
      chunks.push(chunk);
    }

    return chunks;
  }
}
